import { Component, OnInit, ViewChild } from '@angular/core';
const screenfull = require('screenfull');
const browser = require('jquery.browser');
declare var $: any;

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { MenuService } from '../../core/menu/menu.service';
import { ThemesService } from '../../core/themes/themes.service';
import { CadastroModalUtil } from '../../util/modal/cadastro.modal.util';
import { AlterarSenhaComponent } from '../../shared/componentes/alterar-senha/alterar-senha.component';
import { AlterarSenhaAuxModel } from '../../util/model/alterar-senha-aux.model';
import { UtilService } from '../../util/util.service';
import { SessaoUtil } from '../../util/sessao-util';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton') fsbutton;  // the fullscreen button

    constructor(
      public menu: MenuService,
      public userblockService: UserblockService,
      public settings: SettingsService,
      private themesService: ThemesService,
      private cadastroModalUtil: CadastroModalUtil,
      private sessaoUtil: SessaoUtil
    ) {
        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0,4); // for horizontal layout

    }

    ngOnInit() {
        this.isNavSearchVisible = false;
        if (browser.msie) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleCollapsedSideabar() {
        this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
    }

    isCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }

    toggleFullScreen(event) {

        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        let el = $(this.fsbutton.nativeElement);
        if (screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        }
        else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }

    getLogomarca(){
      return this.themesService.getLogomarca();
    }

    getLogo(){
      return this.themesService.getLogo();
    }

    getLogoAts(){
      return this.themesService.getLogoAts();
    }

    alterarSenha(event){
      this.cadastroModalUtil.openModal(AlterarSenhaComponent, 'max-tamanho-350');
    }

    logout(event){
      this.sessaoUtil.logoff();
    }

    meusDados(event){
      this.sessaoUtil.meusDados();
    }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts